/**
 *  Colors
 */
const primary = '#FF652B';
const primaryDark = '#FE3A0C';
const primaryUltraLight = '#FFEFE9';
const primaryLight = '#FF8A5E';
const secondary = '#585992';
const secondaryDark = '#454672';
const secondaryUltraLight = '#EEEEF3';
const secondaryLight = '#68699D';
const tertiary = '#F1D40D';
const tertiaryLight = '#FFE740';
const tertiaryDark = '#F1BF0D';
const tertiaryUltraLight = '#FFF3C6';
const greyScale100 = '#000018';
const greyScale84 = '#29293D';
const greyScale72 = '#474759';
const greyScale60 = '#666474';
const greyScale48 = '#858590';
const greyScale36 = '#A3A3AC';
const greyScale24 = '#C2C2C8';
const greyScale16 = '#D6D6DA';
const greyScale8 = '#EBEBED';
const greyScale4 = '#F5F5F6';
const greyScale0 = '#FFFFFF';
const success = '#07862B';
const info = '#259DD5';
const warning = '#FAB006';
const danger = '#EC0000';
const successUltralLight = '#F0F8F2';
const infoUltralLight = '#F2F9FC';
const warningUltralLight = '#FFFAF0';
const dangerUltraLight = '#FEF2F2';
const extra = '#088ACA';
const extraDark = '#2E9DCD';
const extraLight = '#47B0E2';
const extraUltraLight = '#F0F8FF';
/**
 * Background color for `<body>`.
 */
const bodyBg = '#EEEEEE';
const toggleBackground = '#9899DA';
const colors = {
    primary: {
        ultraLighten: primaryUltraLight,
        normal: primary,
        lighten: primaryLight,
        darken: primaryDark,
    },
    secondary: {
        ultraLighten: secondaryUltraLight,
        normal: secondary,
        lighten: secondaryLight,
        darken: secondaryDark,
    },
    extra: {
        ultraLighten: extraUltraLight,
        normal: extra,
        lighten: extraLight,
        darken: extraDark,
    },
    tertiary: {
        ultraLighten: tertiaryUltraLight,
        lighten: tertiaryLight,
        normal: tertiary,
        darken: tertiaryDark,
    },
    grey100: greyScale100,
    grey84: greyScale84,
    grey72: greyScale72,
    grey60: greyScale60,
    grey48: greyScale48,
    grey36: greyScale36,
    grey24: greyScale24,
    grey16: greyScale16,
    grey8: greyScale8,
    grey4: greyScale4,
    grey0: greyScale0,
    info: {
        normal: info,
        lighten: infoUltralLight,
    },
    success: {
        normal: success,
        lighten: successUltralLight,
    },
    warning: {
        normal: warning,
        lighten: warningUltralLight,
    },
    danger: {
        normal: danger,
        lighten: dangerUltraLight,
    },
    'body-bg': bodyBg,
    toggleBackground: toggleBackground,
};
export default colors;
